import { createGlobalStyle } from 'styled-components';
import img from './lain1.jpg';

const PracticeQFStyle = createGlobalStyle`
body {
    background: url(${img}) no-repeat center center fixed;
    background-size: cover;
    background-color: #0a0a0a;
    font-family: Arial, sans-serif;
    font-size: 16px;
    color: #ff69b4;
    margin: 0;
    padding: 0;
    min-height: 100vh;
    overflow-x: hidden;
}

/* Question Main Container */
.question-main {
    min-height: calc(100vh - 140px);
    padding: 2rem 1rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.question-container {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    animation: fadein 1s ease-in-out;
}

/* Question Card */
.question-card {
    padding: 2rem;
    background: linear-gradient(135deg, rgba(20, 10, 20, 0.75) 0%, rgba(40, 20, 40, 0.75) 100%);
    border: 2px solid #ff1493;
    border-radius: 10px;
    box-shadow: 20px 20px 20px rgba(255, 20, 147, 0.3), 10px 10px 20px rgba(255, 105, 180, 0.3);
    animation: electricbox 0.8s infinite, shadow-move-pink 4s infinite alternate;
    transition: box-shadow 0.3s ease-in-out;
    backdrop-filter: blur(5px);
    position: relative;
    overflow: hidden;
}

.question-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: repeating-linear-gradient(
        0deg,
        transparent,
        transparent 2px,
        rgba(255, 20, 147, 0.03) 2px,
        rgba(255, 20, 147, 0.03) 4px
    );
    animation: scan 10s linear infinite;
    pointer-events: none;
}

@keyframes scan {
    0% { transform: translateY(0); }
    100% { transform: translateY(50%); }
}

.question-card:hover {
    box-shadow: 0 0 40px rgba(255, 20, 147, 0.6), inset 0 0 30px rgba(255, 20, 147, 0.2);
    border-color: #ff69b4;
}

/* Question Header */
.question-header {
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    z-index: 1;
}

.question-type {
    font-size: 1.25rem;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 0 10px rgba(255, 105, 180, 0.6);
    margin: 0 0 0.5rem 0;
}

.question-number {
    font-size: 2rem;
    font-weight: bold;
    color: #ff1493;
    text-shadow: 0 0 15px rgba(255, 20, 147, 0.8);
    background: rgba(0, 0, 0, 0.6);
    display: inline-block;
    padding: 0.5rem 1.5rem;
    border-radius: 10px;
    border: 2px solid #ff1493;
    margin: 0;
    animation: electric 0.8s infinite;
}

/* Question Text */
.question-text-container {
    margin: 2rem 0;
    position: relative;
    z-index: 1;
}

.question-text {
    background: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    font-size: 1.25rem;
    font-weight: bold;
    padding: 1.5rem;
    border-radius: 10px;
    border: 2px solid #ff1493;
    text-align: center;
    text-shadow: 0 0 10px rgba(255, 105, 180, 0.6);
    box-shadow: 0 0 20px rgba(255, 20, 147, 0.3);
    margin: 0;
}

.answer-prompt {
    font-size: 1.25rem;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 0 10px rgba(255, 20, 147, 0.6);
    text-align: center;
    margin: 2rem 0 1.5rem 0;
    position: relative;
    z-index: 1;
}

/* Form */
.question-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    position: relative;
    z-index: 1;
}

.answer-textarea {
    width: 100%;
    padding: 1rem;
    background: rgba(0, 0, 0, 0.8);
    border: 2px solid #ff1493;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(255, 20, 147, 0.3);
    font-size: 1rem;
    color: #ffffff;
    font-family: Arial, sans-serif;
    resize: vertical;
    transition: all 0.3s ease;
    box-sizing: border-box;
}

.answer-textarea::placeholder {
    color: rgba(255, 105, 180, 0.6);
}

.answer-textarea:hover {
    border-color: #ff69b4;
    box-shadow: 0 0 20px rgba(255, 20, 147, 0.5);
}

.answer-textarea:focus {
    outline: none;
    border-color: #ff69b4;
    box-shadow: 0 0 20px rgba(255, 20, 147, 0.5);
}

/* File Input */
.file-input-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.file-instruction {
    font-size: 1.1rem;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 0 10px rgba(255, 105, 180, 0.6);
    margin: 0;
}

.file-input {
    padding: 0.75rem;
    background: rgba(0, 0, 0, 0.8);
    border: 2px solid #ff1493;
    border-radius: 5px;
    color: #ffffff;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
}

.file-input:hover {
    border-color: #ff69b4;
    box-shadow: 0 0 20px rgba(255, 20, 147, 0.5);
}

/* Button Group */
.button-group {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 1rem;
}

.submit-btn,
.reset-btn {
    padding: 1rem 2rem;
    border: 2px solid #ff69b4;
    border-radius: 5px;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.submit-btn {
    background: linear-gradient(135deg, #ff1493 0%, #ff69b4 100%);
    color: #ffffff;
    box-shadow: 0 0 20px rgba(255, 20, 147, 0.4);
}

.submit-btn:hover:not(:disabled) {
    box-shadow: 0 0 40px rgba(255, 20, 147, 0.8), inset 0 0 20px rgba(255, 20, 147, 0.3);
    animation: electric 0.8s infinite;
    background: linear-gradient(135deg, #ff69b4 0%, #ff1493 100%);
}

.submit-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #666;
}

.reset-btn {
    background: rgba(0, 0, 0, 0.6);
    color: #ffffff;
    box-shadow: 0 0 10px rgba(255, 20, 147, 0.3);
}

.reset-btn:hover {
    background: rgba(255, 20, 147, 0.2);
    border-color: #ff1493;
    box-shadow: 0 0 30px rgba(255, 20, 147, 0.6);
}

/* Animations */
@keyframes electric {
    0% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        filter: drop-shadow(0 0 5px currentColor);
    }
    50% {
        text-shadow: 0 0 10px currentColor, 0 0 20px currentColor;
        filter: drop-shadow(0 0 15px currentColor);
    }
    100% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        filter: drop-shadow(0 0 5px currentColor);
    }
}

@keyframes electricbox {
    0% {
        box-shadow: 0 0 10px rgba(255, 20, 147, 0.3), inset 0 0 10px rgba(255, 20, 147, 0.1);
    }
    50% {
        box-shadow: 0 0 30px rgba(255, 20, 147, 0.6), inset 0 0 20px rgba(255, 20, 147, 0.2);
    }
    100% {
        box-shadow: 0 0 10px rgba(255, 20, 147, 0.3), inset 0 0 10px rgba(255, 20, 147, 0.1);
    }
}

@keyframes shadow-move-pink {
    0% {
        box-shadow: 0 0 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
    }
    25% {
        box-shadow: 10px 10px 10px rgba(255, 105, 180, 0.4), 0 0 20px rgba(255, 20, 147, 0.4);
    }
    50% {
        box-shadow: 20px 10px 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
    }
    75% {
        box-shadow: -10px -10px 10px rgba(255, 105, 180, 0.4), 0 0 20px rgba(255, 20, 147, 0.4);
    }
    100% {
        box-shadow: -10px -10px 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
    }
}

@keyframes fadein {
    from {
        transform: translateY(-50px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Nav Menu Hover Effects */
nav ul li a, nav ul li button {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
}

nav ul li a:hover, nav ul li button:hover {
    color: #ff1493;
    text-shadow: 1px 1px 2px #ff1493, 0 0 1em #ff1493, 0 0 0.2em #ff69b4;
    transition: text-shadow 0.3s ease;
    animation: electric 0.8s infinite;
}

nav ul li button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

/* Footer - Handled by EnhancedFooter component */
/* footer {
    margin-top: auto;
    height: 60px;
    background-color: #333;
    color: #fff;
    text-align: center;
    font-size: 18px;
    padding-top: 20px;
} */

/* Responsive Design */
@media (max-width: 768px) {
    .question-main {
        padding: 1rem 0.75rem;
    }

    .question-card {
        padding: 1.5rem;
    }

    .question-type {
        font-size: 1.1rem;
    }

    .question-number {
        font-size: 1.5rem;
    }

    .question-text {
        font-size: 1.1rem;
        padding: 1rem;
    }

    .button-group {
        flex-direction: column;
    }

    .submit-btn,
    .reset-btn {
        width: 100%;
    }
}
`;

export default PracticeQFStyle;